import { render, staticRenderFns } from "./mail_recovery_update.vue?vue&type=template&id=70e769fd&scoped=true&"
import script from "./mail_recovery_update.vue?vue&type=script&lang=js&"
export * from "./mail_recovery_update.vue?vue&type=script&lang=js&"
import style0 from "./mail_recovery_update.vue?vue&type=style&index=0&id=70e769fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e769fd",
  null
  
)

export default component.exports